import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export default function usePaymentPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  return {
    canAddPayment: permissions.includes("entity.add_payment"),
    canEditPayment: permissions.includes("entity.change_payment"),
    canDeletePayment: permissions.includes("entity.delete_payment"),
    canViewPayment: permissions.includes("entity.view_payment"),
  };
}
